import axios from "axios";

import Navbar from './Navbar'
import Topbar from './Topbar'

import {useState, useEffect} from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {APIURL} from './config'
import Loading from './Loading'

function IdeiaUnica() {

    const locate = useLocation()

    const navigate = useNavigate()

    const [results, setResults] = useState()
    const [messages, setMessages] = useState([])
    const [messagescodes, setMessagescodes] = useState()

    const [resultsanalise, setResultsAnalise] = useState([])
    const [messagesanalise, setMessagesAnalise] = useState()
    const [formsanalise, setFormsAnalise] = useState([])
    const [anexosanalise, setAnexosAnalise] = useState([])
    const [btnText, setBtnText] = useState('Enviar');

    const myid = locate.state.ideia_id

    let tipomessage


    useEffect(() => {
        if (!sessionStorage.getItem("tokeninovacao")) {
            navigate('/login')
        }
        listresume( sessionStorage.getItem("tokeninovacao"))
        veranalise( sessionStorage.getItem("tokeninovacao"))
    }, [])

    const listresume= async (mytoken) => {
        
        try {
            const res = await axios.post(`${APIURL}/Inovation/Idea`, {TOKEN : mytoken, Id :myid});
            if (res.data) {
                setResults(res.data);
                setMessages(res.data.Messages.slice(0,-1))
                if (messages) {
                    setMessagescodes(Object.keys(messages))
                }
            }
        } catch (err) {
            alert("Ocorreu um erro. Tente novamente.");
        }
    }  

    const veranalise= async (mytoken) => {
        
        try {
            const res = await axios.post(`${APIURL}/Process/Tasks`, {TOKEN : mytoken, Id_Process: myid, Status: "Terminado", Type: "Análise"});
            if (res.data.length > 0) {
                const res2 = await axios.post(`${APIURL}/Process/IdentifyTask`, {TOKEN : mytoken, Id: res.data[0].ID});
                setResultsAnalise(res2.data.Messages);
                //setMessagesAnalise(res2.data.Messages.filter((Id_Associated_Item) => Id_Associated_Item = res2.data[0].ID))
                //alert(res2.data.Messages)
                setFormsAnalise(res2.data.Forms)
                setAnexosAnalise(res2.data.Attachments)
            }
        } catch (err) {
            alert("Ocorreu um erro na analise. Tente novamente.");
        }
    }  

    const cancel= async () => {
        
        try {
            const res = await axios.post(`${APIURL}/Process/Cancel`, {TOKEN : sessionStorage.getItem("tokeninovacao"), Id_Process: myid, Motive: "Cancelado pelo Usuário"});
            alert(myid)
            if (res.Return) {
                alert("Ideia cancelada!")
                navigate("/ideias")
            }
        } catch (err) {
            alert("Ocorreu um erro no cancelamento. Tente novamente.");
        }
    }  

    const enviar= async () => {
        setBtnText('Enviando...'); // muda o texto ao iniciar
        try {
            const res = await axios.post(`${APIURL}/Process/StartWorkflow`, {TOKEN : sessionStorage.getItem("tokeninovacao"), Id: myid});
            if (res.data.Return) {
                navigate("/ideias")
            }
        } catch (err) {
            alert("Ocorreu um erro no envio. Tente novamente.");
        }
        setBtnText('Enviar'); // muda o texto ao iniciar
    }  

    function retornadata(data) {
        let myday
        let mymonth
        let myyear
        if (data && isNaN(new Date(data).getDate())) {
            //não converteu direito
            myday = data.substring(0, 2)
            mymonth = data.substring(3, 5)
            myyear = data.substring(6,10)
        } else {
            myday = new Date(data).getDate()
            mymonth = new Date(data).getMonth()+1
            myyear = new Date(data).getFullYear()
        }
        const mydate = myday + '/' + mymonth + '/' + myyear
        return mydate
    }

    function verificadata(data) {
        // if (isNaN(new Date(data).getFullYear())) {
        //     return 0
        // } else {
        //     return 1
        // }
        return new Date(data).getFullYear()
            
    }

    return (
        <div>
            <Topbar />
            {results ?
            
                <div className="container py-4 px-2 px-md-5 ">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="h4 mb-0">Ideia #{results.Number}</div>
                        <div className="d-flex justify-content-between align-items-center gap-2">
                            <div>
                                <Link to="/novaideia"><button className="btn btn-sm  btn-success" ><i className="bi bi-pencil fs-6 "></i> Editar </button></Link>
                            </div>
                            <div className="" >
                                <button onClick={() => cancel()}className="btn btn-sm  btn-success" ><i className="bi bi-x fs-6 "></i> Cancelar </button>
                            </div>
                            {results.Status == "em Preenchimento" &&
                                <div className="" >
                                    <button id="btnEnviar" onClick={() => enviar()}className="btn btn-sm  btn-success" ><i className="bi bi-cursor fs-6 "></i> {btnText} </button>
                                </div>
                            }
                        </div>
                    </div>

                   

                    <div className="bg-white shadow-sm p-5">
                       

                        <div className="row ">
                            <div className="col-12 col-md-8 ">
                                <table className="table">
                                <tbody>
                                    <tr>
                                        <td className="fw-bold ">Ideia:</td>
                                        <td>{results.Name}</td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">Descrição:</td>
                                        <td>{results.Description}</td>
                                    </tr>
                                    <tr>
                                        <td className="fw-bold">Criada em:</td>
                                        <td>{retornadata(results.Creation_Date)}</td>
                                    </tr>
                                   {results.Status != "em Preenchimento" &&
                                    <tr>
                                        <td className="fw-bold">Etapa:</td>
                                        <td>{results.Stage}</td>
                                    </tr>
                                    }
                                </tbody>
                                </table>
                                
                            </div>
                            <div id="cardStatus" className="col-12 col-md-4 d-flex justify-content-end ">
                                <div className="card rounded-3 shadow-sm p-3 w-75 h-100 d-flex justify-content-center align-items-center ">
                                    <h4>STATUS</h4>
                                    {(results.Approved == true && verificadata(results.Approval_Date) != 1 )
                                    ?
                                        <h2>Aprovado</h2>
                                    :
                                        (results.Approved== false && verificadata(results.Approval_Date) != 1)
                                        ?
                                            <h2>Reprovado</h2>
                                        :
                                        <h2 className="text-center">{results.Status}</h2>
    
                                    }
                                </div>
                            </div>
                        </div>

                            
                            
                                    
                        
                        <div className="d-flex flex-row justify-content-between mt-5 align-items-center mb-2" >
                            <div >
                                <h5 className="fw-bold mb-0">Comentários</h5>
                            </div>
                            <div >
                                <Link to="/novocomentarioideia" state={{ideia_id: myid, titulo: results.Name}}><button className="btn btn-success btn-sm" type="submit">Novo Comentário</button></Link>
                            </div>
                        </div>

                            <div className="mt-2">
                            {messages && messages.map((subitem, i) => {
                                tipomessage = subitem.IsProcessMessage
                                if (tipomessage == true && subitem.Description.includes("Finalizada") == false) {
                                    return (
                                        <div className=" p-3 bg-light mb-3"  key={i}>
                                            <div className="fw-bold">{subitem.User}</div>
                                            <div className="fw-light small" >{retornadata(subitem.Creation_Date)}</div>
                                            <div className="mx-2">{subitem.Description}</div>
                                        </div>
                                        
                                    )
                                    }
                            })}
                            </div>

                            {sessionStorage.getItem("tipousuario") != 4 && resultsanalise.length>0 &&
                            <div>
                                <div className="d-flex flex-row justify-content-between mt-5 align-items-center" >
                                    <div >
                                        <h5 className="fw-bold">Análise</h5>
                                    </div>
                                    <div >
                                        <Link to="/novocomentarioideia" state={{ideia_id: myid, titulo: results.Name}}><button className="btn btn-outline btn-sm btn-success" type="submit">Novo Comentário</button></Link>
                                    </div>

                                </div>
                                    
                                <div className="mt-2" >
                                    {resultsanalise && [resultsanalise].map((subitem, i) => {
                                        return (
                                            <div className=" p-3 bg-light mb-3"  key={i}>
                                                <div className="fw-bold">{subitem.Executer}</div>
                                                <div className="fw-light small" >{retornadata(subitem.Finish_Date)}</div>
                                                <div className="mx-2">{subitem.Description}</div>
                                            </div>
                                        )
                                        })
                                    }
                                </div>
                            </div>
                            
                            }
                    
                    
                    </div>
                </div> 
            :
                <Loading />
            }
        </div>
      );
    }
    
    export default IdeiaUnica;
